module.exports = __webpack_public_path__ + "img/technology.fa7b98b0.jpg";